import { Injectable } from '@angular/core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class ApCateAddConfigService {
  
  getApCateConfig(): InlineAddConfig {
    return {
      modelType: 'suppliercategory',
      title: 'Supplier Category',
      apiEndpoint: 'api/suppliercategories/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'supplierCategoryCode': 'code'
      },
      selectionConfig: {
        targetField: 'supplierCategoryId',
        valueField: 'id',
        labelField: 'code'
      },  
      hiddenData: {
        isActive: true,
      },
      fields: [
        {
          name: 'code',
          label: 'Category #',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Enter category number',
          size: 'half',
          isInstantData: true
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter category name',
          size: 'half'
        },
        
        {
          name: 'isDefault',
          label: 'Default',
          type: 'switch',
          required: false,
          size: 'half',
          defaultValue: false
        }
      ],
      showMoreDetails: false
    };
  }
}
